module.exports = __webpack_public_path__ + "images/emoji/factory.141284623106b79235df.png";